import { Inject, Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class InputNumberService {

  constructor(
    @Inject('INPUT_NUMBER_DECIMALS') private decimals: number = -1,
    @Inject('INPUT_NUMBER_FORMAT_CERO') private formatCero: boolean = false,
    @Inject('INPUT_NUMBER_BTN_ENABLE') private btnEnable: boolean = false,
    @Inject('INPUT_NUMBER_BOLD') private bold: boolean = false,
    @Inject('INPUT_NUMBER_VALIDATOR_MESSAGE') private validatorMessage: boolean = false,
    @Inject('INPUT_NUMBER_TOOLTIP_MESSAGE') private tooltipMessage: boolean = true,
    @Inject('INPUT_NUMBER_SUBMITTED') private submitted: boolean = true,
    @Inject('INPUT_NUMBER_VALIDATOR_ALERT') private validatorAlert: boolean = false
  ) {
  }


  public getDecimals(): number {
    return this.decimals;
  }
  public getFormatCero(): boolean {
    return this.formatCero;
  }
  public getBtnEnable(): boolean {
    return this.btnEnable;
  }
  public getBold(): boolean {
    return this.bold;
  }
  public getValidatorMessage(): boolean {
    return this.validatorMessage;
  }
  public getTooltipMessage(): boolean {
    return this.tooltipMessage;
  }
  public getSubmitted(): boolean {
    return this.submitted;
  }
  public getValidatorAlert(): boolean {
    return this.validatorAlert;
  }
  
  
}